<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-form ref="form">
        <v-dialog v-if="isView" v-model="isView" persistent>
            <v-card class="mt-3 pa-1">
                <Title title="ユーザー検索">
                    <v-spacer />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView=false" />
                </Title>
                <v-card outlined class="mt-1 pa-1">
                    <Title title="検索条件" dense @click="isExpand = !isExpand">
                        <v-spacer />
                        <v-btn small icon elevation="0" @click.stop="isExpand = !isExpand">
                            <v-icon v-if="isExpand">mdi-chevron-up</v-icon>
                            <v-icon v-if="!isExpand">mdi-chevron-down</v-icon>
                        </v-btn>
                    </Title>
                    <v-expand-transition>
                        <v-card-text v-if="isExpand">
                            <v-container fluid class="pa-0">
                                <v-row dense><v-col>
                                    <v-text-field v-model="params.name"
                                        dense 
                                        clearable 
                                        label="名前"
                                        outlined 
                                        persistent-hint
                                        hint="名前でユーザーを検索します。" />
                                </v-col></v-row>
                                <v-row dense>
                                    <v-col cols="12" xs="12" sm="4" md="4" lg="3" xl="3">
                                        <v-text-field v-model="params.address.postalCode" 
                                            v-mask="maskPostal"
                                            dense 
                                            clearable 
                                            label="郵便番号"
                                            outlined 
                                            persistent-hint
                                            hint="郵便番号でユーザーを検索します。" />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="4" md="4" lg="3" xl="3">
                                        <v-text-field v-model="params.address.pref" 
                                            dense 
                                            clearable 
                                            label="県"
                                            outlined 
                                            persistent-hint
                                            hint="県名でユーザーを検索します。" />
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="4" md="4" lg="3" xl="3">
                                        <v-text-field v-model="params.address.city" 
                                            dense 
                                            clearable 
                                            label="市"
                                            outlined 
                                            persistent-hint
                                            hint="市名でユーザーを検索します。" />
                                    </v-col>
                                </v-row>
                                <v-row dense><v-col>
                                    <v-btn class="primary" @click="onClickSearch">
                                        <v-icon>mdi-account-search</v-icon>
                                        検索
                                    </v-btn>
                                </v-col></v-row>
                            </v-container>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
                <v-card outlined class="mt-1 pa-1">
                    <Title title="ユーザー一覧" dense />
                    <v-card-text class="pa-0">
                        <v-simple-table fixed-header v-if="users != null && users.length > 0">
                            <tbody>
                                <tr>
                                    <td>
                                        <v-container fluid v-if="users != null && users.length > 0">
                                            <v-row justify="start">
                                                <v-col v-for="user in users" :key="user.userData.userUID" cols="12" xs="12" sm="6" md="4" lg="3" xl="3" align="center">
                                                    <v-card max-width="300" @click="onClickUser(user)" >
                                                        <div class="d-flex flex-no-wrap">
                                                            <v-avatar class="ma-3" rounded>
                                                                <v-img v-if="user.userData.avaterImage == null" src="@/assets/no_avater_image.png"/>
                                                                <v-img v-if="user.userData.avaterImage != null" :src="user.userData.avaterImage.url"/>
                                                            </v-avatar>
                                                            <div class="mt-3">
                                                                <table>
                                                                    <tr>
                                                                        <td class="subtitle-1 text-no-wrap">{{user.userData.userName}}</td>
                                                                    </tr>
                                                                    <tr v-if="user.userData.publicSetting == 3">
                                                                        <td class="caption text-no-wrap">{{user.userData.address.pref}}{{user.userData.address.city}}</td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </v-card>          
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div v-else-if="users != null && isSeaching" style="width:100%; text-align:center;">
                            <v-progress-circular indeterminate class="mt-2 mb-2" />
                        </div>
                        <div v-else-if="users != null && !isSeaching" style="width:100%; text-align:center;" class="red pt-1 pb-1 white--text">
                            検索条件に該当するユーザーが見つかりませんでした。
                        </div>
                        <div v-else style="width:100%; text-align:center;" class="white pt-1 pb-1 black--text">
                            検索ボタンをクリックすると、ここに該当するユーザーが表示されます。
                        </div>
                    </v-card-text>
                </v-card>
            </v-card> 
        </v-dialog>
    </v-form>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import {mask} from 'vue-the-mask';
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        directives: {
            mask
        },
        props: [
            // 除外するユーザーのユーザーIDが格納された配列
            "excludeUserIDList"
        ],
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
        },
        data: function () {
            return {
                maskPostal: "###-####",
                finderOpened: 0,    // 検索部を強制展開
                isView:false,
                params: {
                    // id: "",
                    name: "",
                    address: {
                        postalCode: "",
                        pref: "",
                        city: "",
                    }
                },
                users: null,
                isSeaching: false,
                isExpand: true
            }
        },
        methods: {
            show: function(){
                console.log("除外リスト", this.excludeUserIDList)
                this.params = {
                    name: "",
                    address: {
                        postalCode: "",
                        pref: "",
                        city: "",
                    }
                }
                this.users = null
                this.isView = true
            },
            close: function () {
                this.isView = false
            },
            onClickUser: function (user) {
                // user: {
                //     userUID:
                //     userData:
                // }
                this.$emit("onSelectedUser", user)
                // this.isView = false
            },
            onClickSearch: async function () {

                this.isSeaching = true

                try {
                    this.users = []
                    this.params.name = this.params.name == null ? "" : this.params.name
                    this.params.address.postalCode = this.params.address.postalCode == null ? "" : this.params.address.postalCode
                    this.params.address.pref = this.params.address.pref == null ? "" : this.params.address.pref
                    this.params.address.city = this.params.address.city == null ? "" : this.params.address.city

                    const self = this
                    await db.collection("users").where("publicSetting", ">", 0).limit(10).get().then(function(snapShot){
                        const num = snapShot.size
                        var cnt = 0
                        console.log("ユーザー検索件数", snapShot.size)
                        snapShot.forEach(function(doc){                        
                            const user = doc.data()
                            // 自分以外のユーザーを対象とする
                            if (user.userUID != self.userData.userUID) {
                                // 除外リストに登録されていないユーザーを対象
                                if (self.excludeUserIDList == null || self.excludeUserIDList.findIndex((v) => v === user.userUID) < 0) {
                                    console.log("除外リストに含まれていないユーザー", user)
                                    // 検索条件に該当すれば、配列に追加
                                    // const resultID = (self.params.id == "" || (self.params.id != "" && user.userID == self.params.id))
                                    const resultName = (self.params.name == "" || (user.publicSetting != 0 && user.userName.indexOf(self.params.name) != -1))
                                    const resultPostalCode = (self.params.address.postalCode == "" || (user.publicSetting == 3 && user.address.postalCode.indexOf(self.params.address.postalCode) != -1))
                                    const resultPref = (self.params.address.pref == "" || (user.publicSetting == 3 && user.address.pref.indexOf(self.params.address.pref) != -1)) 
                                    const resultCity = (self.params.address.city == "" || (user.publicSetting == 3 && user.address.city.indexOf(self.params.address.city) != -1))
                                    
                                    console.log(self.params, resultPostalCode,resultPref,resultCity)
                                    if (resultName && resultPostalCode && resultPref && resultCity) {
                                        self.users.push({userData:user, userUID:doc.id})
                                    }
                                } else {
                                    console.log("除外リストに含まれるユーザー", user)
                                }
                            } else {
                                console.log("自分", user)
                            }
                            cnt++
                            if (cnt == num && self.users.length > 0) {
                                // self.finderOpened = undefined
                            }
                        })
                    }).catch(function(error){
                        console.log(error)
                        self.mi_writeLog("UserFinder/onClickSearch", "ユーザー検索処理失敗("+error+")")
                    })
                } finally {
                    this.isSeaching = false
                }
            }
        }
    }
</script>
